<script>
// import Translations from "./insert-me-to-translate.vue";

export default {
  name: "PostGalleryModal",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.i18n = {
      back: gettext("Back to the ad"),
      showAll: gettext("Show all")
    }
  }
};
</script>

<template>
  <div>
    <div class="modal modal-fullscreen-xl" id="images-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header detailphoto d-flex justify-content-start">
            <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="fas fa-chevron-left pr-2"></i></span>
            </button>
            <h5 class="modal-title">
              <a data-dismiss="modal" aria-label="Close">{{ i18n.back }}</a>
            </h5>
          </div>
          <div class="modal-body">
            <v-lazy-image v-for="(src,index) in items" :key="`item-${index}`" :src="src"></v-lazy-image>
          </div>
        </div>
      </div>
    </div>
    <button data-toggle="modal" data-target="#images-modal" class="btn btn-open-modal">
      <i class="fas fa-expand mr-2"></i>{{ i18n.showAll }}
    </button>
  </div>
</template>